module.exports = "<span *ngIf=\"model.dataType=='query'\">\r\n    {{value}}%\r\n </span>\r\n <span *ngIf=\"model.dataType=='selectedCity' || model.dataType =='cityToCompare'\">\r\n    <img src=\"assets/images/0{{value}}.png\" *ngIf=\"value==0 || value==1 || value==3|| value==4\"/>\r\n    <span *ngIf=\"value==2\">\r\n        לא רלוונטי\r\n     </span>\r\n </span>\r\n\r\n\r\n\r\n "


//////////////////
// WEBPACK FOOTER
// ./src/app/component/blocks/placeRow/placeRow.component.html
// module id = ./src/app/component/blocks/placeRow/placeRow.component.html
// module chunks = main